import React, { useCallback, useState } from 'react'
import {
  BooleanInput,
  SimpleForm,
  TextInput,
  Confirm,
  email,
  required,
  // ReferenceInput,
  // AutocompleteInput,
  // minLength,
  // useTranslate,
  useUpdate,
  useNotify,
  useRecordContext,
  useRedirect,
} from 'react-admin'
// import PersonIcon from '@mui/icons-material/Person'
import {
  // Typography,
  Grid,
} from '@mui/material'

import { EditBase } from '../../components/base'
import CustomEmailConfigToolbarWithPermission from '../../components/domains/email-config/CustomEmailConfigToolbar'
import { EMAILCONFIG_FIELDS, COMMON_FIELDS } from '../../providers/localization/constant'
import {
  BranchMultiSelectInput, 
  // BranchAutocompleteArrayInput,
} from '../../components/form'
import { EmailConfig } from './type'

export const FormEdit = (): JSX.Element => {
  const [updateData, setUpdateData] = useState({} as EmailConfig)
  const record = useRecordContext()
  const notify = useNotify()
  const [open, setOpen] = useState(false)
  const redirect = useRedirect()
  const handleDialogClose = (): void => setOpen(false)
  // const translate = useTranslate()

  const onError = useCallback(
    (error): void => {
      if (error.response.data.code === '23505'){
        return notify('ra.validation.update_email_config_duplicate' || 'ra.validation.update_email_config_fail', { type: 'error' })
      }
      const errorMessage = error.response.data.message
      return notify(errorMessage || 'ra.validation.update_email_config_fail', { type: 'error' })
    },
    [notify],
  )

  const onSuccess = useCallback(async (): Promise<void> => {
    notify('ra.notification.update_email_config_success', { type: 'success' })
    redirect('/emailconfig')
  }, [notify, redirect])

  const [update, { isLoading }] = useUpdate(undefined, undefined, { onError, onSuccess })

  const handleSubmit = (data): void => {
    const { /* access_branches: accessBranches,*/ ...email } = data
    // email.branch_ids = accessBranches
    setUpdateData(email as EmailConfig)
    setOpen(true)
  }

  const handleConfirm = useCallback(async (): Promise<void> => {
    await update('emailconfig', {
      id: record.id,
      data: { /* encType: 'multipart/form-data',*/...updateData },
      // data: {       
      //   is_active: updateData?.is_active,
      // },
    })
    handleDialogClose()
  }, [update, updateData, record])

  return (
    <SimpleForm onSubmit={handleSubmit} toolbar={<CustomEmailConfigToolbarWithPermission encType='application/json' />}>
      <Confirm
        isOpen={open}
        loading={isLoading}
        title='แก้ไขข้อมูล'
        content='คุณต้องการแก้ไขข้อมูลหรือไม่?'
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
      <Grid container spacing={1} justifyContent='center'>
        <Grid container item spacing={3} xs={12} sm={8} md={6}>
          <Grid item xs={12} sm={6}>
            <TextInput
              source='first_name'
              label={`${EMAILCONFIG_FIELDS}.first_name`}
              InputProps={{
                fullWidth: true,
              }}
              fullWidth
              validate={[required()]}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput
              source='last_name'
              label={`${EMAILCONFIG_FIELDS}.last_name`}
              fullWidth
              validate={[required()]}
            />
          </Grid>
          <Grid item xs={12}>
            <TextInput
              source='email'
              label={`${EMAILCONFIG_FIELDS}.email`}
              type='email'
              InputProps={{
                fullWidth: true,
              }}
              fullWidth
              validate={[required(), email()]}
            />
          </Grid>
          <Grid item xs={12}>
            <BranchMultiSelectInput source='branches' validate={[required()]}>
            
              </BranchMultiSelectInput>
          </Grid>
          <Grid item>
            <BooleanInput
              color='primary'
              source='is_active'
              label={`${COMMON_FIELDS}.status.label`}
            />
          </Grid>
        </Grid>
      </Grid>
    </SimpleForm>
  )
}

export const EmailConfigEdit = (): JSX.Element => {
  const transformEmailConfig = (data): object => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,
    const { ...transformData } = data
    return transformData
  }

  return (
    <EditBase
      title={'resources.emailconfig.edit.title'}
      redirect='list'
      listAction={{
        hasBackButton: true,
        hasShow: false,
      }}
      transform={transformEmailConfig}
      // encType='multipart/form-data'
    >
      <FormEdit />
    </EditBase>
  )
}

export default EmailConfigEdit
